module.exports = __webpack_public_path__ + "static/media/web3-vending-machine.a2794018.png";